"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = useImageRefs;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = require("react");

var _useStorageRef = _interopRequireDefault(require("./useStorageRef"));

var _helpers = require("../helpers");

function useImageRefs(props) {
  var path = props.path,
      filter = props.filter,
      maxResultsProp = props.maxResults,
      onError = props.onError;
  var storageRef = (0, _useStorageRef["default"])();

  var _useState = (0, _react.useState)([]),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      imageRefs = _useState2[0],
      setImageRefs = _useState2[1];

  (0, _react.useEffect)(function () {
    var maxResults = maxResultsProp >= 0 ? maxResultsProp : 1000;
    (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2() {
      var imagesFiltered, _yield$storageRef$chi, items, filteredList, _yield$storageRef$chi2, _items;

      return _regenerator["default"].wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              if (!Array.isArray(filter)) {
                _context2.next = 7;
                break;
              }

              imagesFiltered = [];
              _context2.next = 4;
              return Promise.all(filter.map( /*#__PURE__*/function () {
                var _ref2 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(name) {
                  var imageRef;
                  return _regenerator["default"].wrap(function _callee$(_context) {
                    while (1) {
                      switch (_context.prev = _context.next) {
                        case 0:
                          imageRef = storageRef.child("".concat(path, "/").concat(name));
                          _context.prev = 1;
                          _context.next = 4;
                          return imageRef.getDownloadURL();

                        case 4:
                          imagesFiltered.push(imageRef);
                          _context.next = 10;
                          break;

                        case 7:
                          _context.prev = 7;
                          _context.t0 = _context["catch"](1);
                          onError(_context.t0);

                        case 10:
                        case "end":
                          return _context.stop();
                      }
                    }
                  }, _callee, null, [[1, 7]]);
                }));

                return function (_x) {
                  return _ref2.apply(this, arguments);
                };
              }()));

            case 4:
              setImageRefs(imagesFiltered.slice(0, maxResults));
              _context2.next = 51;
              break;

            case 7:
              if (!(typeof filter === 'function')) {
                _context2.next = 31;
                break;
              }

              _context2.prev = 8;
              _context2.next = 11;
              return storageRef.child(path).listAll();

            case 11:
              _yield$storageRef$chi = _context2.sent;
              items = _yield$storageRef$chi.items;
              filteredList = items.filter(function (ref) {
                return filter(ref);
              }).slice(0, maxResults);
              _context2.t0 = setImageRefs;
              _context2.t1 = _helpers.sortByDate;
              _context2.next = 18;
              return (0, _helpers.attachMetadata)(filteredList);

            case 18:
              _context2.t2 = _context2.sent;
              _context2.next = 21;
              return (0, _context2.t1)(_context2.t2);

            case 21:
              _context2.t3 = _context2.sent;
              (0, _context2.t0)(_context2.t3);
              _context2.next = 29;
              break;

            case 25:
              _context2.prev = 25;
              _context2.t4 = _context2["catch"](8);
              onError(_context2.t4);
              setImageRefs([]);

            case 29:
              _context2.next = 51;
              break;

            case 31:
              _context2.prev = 31;
              _context2.next = 34;
              return storageRef.child(path).list({
                maxResults: maxResults
              });

            case 34:
              _yield$storageRef$chi2 = _context2.sent;
              _items = _yield$storageRef$chi2.items;
              _context2.t5 = setImageRefs;
              _context2.t6 = _helpers.sortByDate;
              _context2.next = 40;
              return (0, _helpers.attachMetadata)(_items);

            case 40:
              _context2.t7 = _context2.sent;
              _context2.next = 43;
              return (0, _context2.t6)(_context2.t7);

            case 43:
              _context2.t8 = _context2.sent;
              (0, _context2.t5)(_context2.t8);
              _context2.next = 51;
              break;

            case 47:
              _context2.prev = 47;
              _context2.t9 = _context2["catch"](31);
              onError(_context2.t9);
              setImageRefs([]);

            case 51:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[8, 25], [31, 47]]);
    }))();
  }, [path, filter, storageRef, onError, maxResultsProp]);
  return [imageRefs, setImageRefs];
}